export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Subhead_Space_After-823e7293c4e979948574eae807b895b2.svg";